/* Shared scroll reveal for the About page sections (sections/about-*.liquid).
   Loaded once per about-* section; the window guard makes repeat executions a no-op. */
(function () {
  if (window.__abReveal) return;

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.04 }
        )
      : null;

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-ab-reveal]');

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.getAttribute('data-ab-bound')) continue;
      node.setAttribute('data-ab-bound', '1');

      var items = node.querySelectorAll('[data-ab-item]');
      for (var j = 0; j < items.length; j++) {
        if (!items[j].style.getPropertyValue('--ab-i')) {
          items[j].style.setProperty('--ab-i', j);
        }
      }

      if (observer) {
        observer.observe(node);
      } else {
        node.classList.add('is-in');
      }
    }
  }

  window.__abReveal = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Sections added, moved or re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
